module.exports = __webpack_public_path__ + "img/manufacturing-icon.cb5701ad.svg";